import { render, staticRenderFns } from "./RateDatatable.vue?vue&type=template&id=f36b17b8"
import script from "./RateDatatable.vue?vue&type=script&lang=js"
export * from "./RateDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports